import {LOG_OUT, PL_LIST, DEFAULT_AGENCY_PROFILE} from "./ActionTypes";

import RevenueGoalService from "../services/RevenueGoalService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});
const plListData = (plList) => ({type: PL_LIST, plList});


export const getPlList = (locationId) => (
    async (dispatch) => {
        try {
            let result = await RevenueGoalService.plList(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(plListData(result.data.pl_profile));
                return result.data.pl_profile;
            }
        } catch (error) {
            console.log(error);
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);


export const getRevenueTarget = (profileId) => (
    async (dispatch) => {
        try {
            let result = await RevenueGoalService.getRevenueTarget(profileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            console.log(error);
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);


export const getRevenueTargetReport = (profileId) => (
    async (dispatch) => {
        try {
            let result = await RevenueGoalService.getRevenueTargetReport(profileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result;
            }
        } catch (error) {
            console.log(error);
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/RevenuaGoalAction.js